import {IComponentOptions} from "angular";
import {getEditableFieldConfiguration} from "../editable-field.component";
import {IEditableField} from "../IEditableField";


export class StateEditableField extends IEditableField {

    public static instance: IComponentOptions = getEditableFieldConfiguration(
        require('./state-editable-field.component.html'),
        [StateEditableField]
    );


}